import React from 'react'
import { Typography } from 'antd'

function PlatformUsageAgreement() {
  return (
    <div style={{display:'flex', justifyContent:'center', flexDirection:'column'}}>
      <Typography.Title style={{textAlign:'center'}} level={2}>Platform Usage Agreement</Typography.Title>
      <a style={{textAlign:'center'}} target="_blank" rel="noopener noreferrer" href={'https://drive.google.com/file/d/1hDKCrCRcagQQr7WHvK1Y5chOB3LWvxC4/view?usp=sharing'}>
        View - Platform Usage Agreement
        </a>
    </div>
  )
}

export default PlatformUsageAgreement